import { Component, OnInit, Input, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { ItemObject } from 'src/app/models/orders/item/item-object.model';
import { OrderDetailsGeneralObject } from 'src/app/models/orders/order-details-general/order-details-general-object.model';
import { OrderDetailsProcessObject } from 'src/app/models/orders/order-details-process/order-details-process-object.model';
import { ProcessTableObject } from 'src/app/models/orders/order-details-process/process-table/process-table-object.model';
import { ProcessDetailsObject } from 'src/app/models/orders/order-details-process/process-details/process-details-object.model';
import { MatDialog, MatDialogRef, MatTableDataSource } from '@angular/material';
import { DetailsService } from 'src/app/services/api/orders/obtain-order-details-process.service';
import { AppService } from 'src/app/app.service';
import { Subscription } from 'rxjs';
import { OrderSummary } from 'src/app/services/api/orders/orders.service';
import { OrderTypeObject } from 'src/app/models/orders/order-type-object.model';
import { OrderStatusObject } from 'src/app/models/orders/order-status-object.model';
import { CharacteristicsConverter } from 'src/app/services/api/characteristics/characteristics.converter';
import { OrderDetailsServicesConverter } from 'src/app/services/api/orders/specific-order/order-details-services.converter';
import { OrderDetailsProductConverter } from 'src/app/services/api/orders/specific-order/order-details-product.converter';
import { OrderDetailsProcessConverter } from 'src/app/services/api/orders/specific-order/order-details-process.converter';
import { BPMService } from 'src/app/services/api/bpm/bpm.service';
import { OrderDetailsProcessBpmActivitiesConverter } from 'src/app/services/api/orders/specific-order/order-details-process-bpmActivities.converter';
import { OrderDetailsProcessActivitiesConverter } from 'src/app/services/api/orders/specific-order/order-details-process-activities.converter';
import { TaskProcessConverter } from 'src/app/services/api/tasks/process-task/process-task.converter';
import { TaskProcessObject } from 'src/app/models/orders/order-details-process/process-details/process-task.model';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { TranslateService } from '@ngx-translate/core';
import { TasksService } from 'src/app/services/api/tasks/tasks.service';
import { JsonComponent } from 'src/app/core/json/json.component';
import { DiagramComponent } from 'src/app/core/diagram/diagram.component';
import { TechnicalSubprocessObject } from 'src/app/models/orders/order-details-process/process-details/technical-subprocess-object.model';
import { CompleteActivityDialogComponent } from './complete-activity-dialog/complete-activity-dialog.component';
import { ScaiService } from 'src/app/services/api/scai/scai.service';
import { ProcessActivityObject } from 'src/app/models/orders/order-details-process/process-details/process-activity-object.model';
import { KeycloakService } from 'keycloak-angular';
import { Role } from 'src/app/utils/Role';

@Component({
  selector: 'app-order-details-processes',
  templateUrl: './order-details-processes.component.html',
  styleUrls: ['./order-details-processes.component.css']
})

export class OrderDetailsProcessesComponent implements OnInit {

  _summary: OrderSummary;
  @Input()
  get summary(): any {
    return this._summary;
  }
  set summary(value: any) {
    this._summary = value;
    this.ngOnInit();
  }

  _params: any;
  @Input()
  get params(): any {
    return this._params;
  }
  set params(value: any) {
    this._params = value;
    this.ngOnInit();
  }

  _isps: any[];
  @Input()
  get isps(): any {
    return this._isps;
  }
  set isps(value: any) {
    this._isps = value;
    this.ngOnInit();
  }

  diagramRef: MatDialogRef<DiagramComponent>;

  previousId: string;

  generalInfo: OrderDetailsGeneralObject;
  processTableList: Array<ProcessTableObject> = new Array<ProcessTableObject>();
  processDetails: ProcessDetailsObject;
  dataSource: MatTableDataSource<ProcessTableObject>;
  columnsToDisplay: string[] = ['processId', 'type', 'status', 'name', 'links'];
  selectedRowId: string;
  generalInfoSubscribe: Subscription;
  appData: any;
  canCompleteActivity : boolean =  false;
  userId: string;
  hasCompleteActivityRole: boolean = false;

  constructor(private detailsService: DetailsService,
    private appService: AppService, private characteristicsConverter: CharacteristicsConverter,
    private serviceConverter: OrderDetailsServicesConverter, private productConverter: OrderDetailsProductConverter,
    private processConverter: OrderDetailsProcessConverter, private bpmService: BPMService,
    private subprocessesConverter: OrderDetailsProcessBpmActivitiesConverter,
    private processActivitiesConverter: OrderDetailsProcessActivitiesConverter,
    private taskProcessConverter: TaskProcessConverter,
    private notificationsService: NotificationsService,
    private translateService: TranslateService,
    private tasksService: TasksService,
    private scaiService: ScaiService,
    public dialog: MatDialog,
    public keycloakService: KeycloakService) {


  }

  /*
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.item) {
      this.item = changes.item.currentValue;
    }
    if (changes.params) {
      this.params = changes.params.currentValue;
    }
    if (changes.summary) {
      this.summary = changes.summary.currentValue;
    }
    if (changes.isps) {
      this.isps = changes.isps.currentValue;
    }
    this.ngOnInit();
  }
  */

  ngOnInit() {

    const keycloakTokenParsed = this.keycloakService.getKeycloakInstance().tokenParsed;
    this.userId = keycloakTokenParsed['preferred_username'];
    this.hasCompleteActivityRole = this.keycloakService.getUserRoles().includes(Role.CompleteProcess);


    if (this.params && this.summary && this.isps && (this.previousId !== this._summary.id || this._summary.isReload)) {
      this.previousId = this.summary.id;
      this.processDetails = ProcessDetailsObject.create();
      this.appData = this.appService.settings;

      this.clearProcesses();

      this.generalInfo = new OrderDetailsGeneralObject(this.summary.id, OrderStatusObject.createWithStatus(this.summary.state),
        this.summary.domain,
        OrderTypeObject.createWithType(this.summary.type.name), this.summary.id, this.summary.status, this.summary.externalId,
        this.summary.priority, this.summary.urgent, new Date(this.summary.requestStartDate), new Date(this.summary.expectedStartDate),
        this.characteristicsConverter.convert(this.summary.listsCharacteristic),
        this.summary.cancellationMotive, this.productConverter.convert(this.summary), this.serviceConverter.convert(this.summary),
        this.summary.cancellable, this.processConverter.convert(this.summary));


      this.setDatasourceProcessesTable(this.generalInfo.getProcesses(), this.generalInfo);
    }
  }

  ngOnDestroy(): void {
  }

  setDatasourceProcessesTable(orderDetailsProcesses: Array<OrderDetailsProcessObject>, generalInfo: OrderDetailsGeneralObject): void {

    for (const orderDetailsProcess of orderDetailsProcesses) {
      const processTable = new ProcessTableObject(
        orderDetailsProcess.getProcessId(),
        orderDetailsProcess.getType(),
        orderDetailsProcess.getName(),
        orderDetailsProcess.getStatus());
      orderDetailsProcess.setTable(processTable);

      this.bpmService.getProcessDetails(orderDetailsProcess.getProcessId()).subscribe(
        (data) => {
          const tasks = new Array<TaskProcessObject>();
          for (const task of data.tasks) {
            tasks.push(this.taskProcessConverter.convert(task));
          }
          orderDetailsProcess.setDetails(
            new ProcessDetailsObject(
              orderDetailsProcess.getProcessId(), null, null, this.processActivitiesConverter.convert(data),
              this.subprocessesConverter.convert(data), undefined,
              tasks, orderDetailsProcess.isFetched()
            )
          );

          if (orderDetailsProcess.getProcessId() === generalInfo.getFirstProcessId()) {
            this.dataSource = new MatTableDataSource<ProcessTableObject>(this.processTableList);
            this.selectProcess(generalInfo.getFirstProcessId(), generalInfo.getProcesses());
          }

          this.canCompleteActivity = this.isWaitingForSCAI(this.processDetails.getSubprocessList());

        }
      );

      this.processTableList.push(processTable);
    }

  }

  private clearProcesses() {
    this.processTableList = new Array<ProcessTableObject>();
    this.processDetails = ProcessDetailsObject.create();
  }

  selectProcess(processId: string, processes: Array<OrderDetailsProcessObject>) {
    this.selectedRowId = processId;
    this.displayDetails(processId, processes);
  }
  private displayDetails(processId: string, processes: Array<OrderDetailsProcessObject>) {
    for (let process of processes) {
      if (process.getProcessId() === processId) {
        this.processDetails = process.getDetails();
      }
    }
  }

  public getTaskProcessFlowChart(processId: string) {
    this.tasksService.getTaskProcesses(processId).subscribe(
      (data: string) => {
        /*
        this.diagramRef = this.dialog.open(DiagramComponent, {
          data: { title: 'Diagrama de procesos', diagram: data }
        });
        */
        const diagramWindow = window.open('', '_blank');
        diagramWindow.document.write(data);
      },
      (error) => {
        this.notificationsService.showNotification(this.translateService.instant('TASKS_KEY.diagramError'), NotificationLevel.ERROR);
      }
    )
  }

  private isWaitingForSCAI( subprocess: Array<TechnicalSubprocessObject>) : boolean{

  if (!subprocess.length) return false;
  
  // Find the object with the most recent startDate.
  const mostRecentObject = subprocess.reduce((prev, curr) => {
    return (!prev.getStartDate() || new Date(prev.getStartDate()) < new Date(curr.getStartDate())) ? curr : prev;
  });

  // Check if the most recent object meets the criteria.
  return mostRecentObject.getType().toUpperCase() === 'JOIN' &&
         mostRecentObject.getName().toUpperCase() === 'SCAI_JOIN' &&
         mostRecentObject.getStatus().toUpperCase() === 'STARTED';

}

completeActivity(): void {
  const dialogRef = this.dialog.open(CompleteActivityDialogComponent, {
    disableClose: false,
    minWidth: 150,
    minHeight: 150,

  });

  dialogRef.afterClosed().subscribe(result => {
    if (result.status === 'OK' || result.status === 'KO') {
      this.scaiService.completeActivity(this._summary.serviceRef, this._summary.processes[0].originIdScai, result.status, result.comment, this.userId).subscribe(
        (data) => {
          this.notificationsService.showNotification('Actividad completada correctamente', NotificationLevel.SUCCESS);
        },
        (error) => {
          this.notificationsService.showNotification('Ha habido un problema al completar la actividad', NotificationLevel.ERROR);
        }
      );
  }
});

}

reloadSchema() : void {
  this.clearProcesses();
  this.setDatasourceProcessesTable(this.generalInfo.getProcesses(), this.generalInfo);
}

}